import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminArticles from "@/pages/AdminArticles";
import AdminArticleEdit from "@/pages/AdminArticleEdit";
import Gacha from "@/pages/Gacha";
import AdminGacha from "@/pages/AdminGacha";
import { PRIVACY, TERMS } from "@/content/legal";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { AdminStatusBadge } from "@/components/site/AdminStatusBadge";
import { Analytics } from "@/components/site/Analytics";

const Admin = ({ children }) => <AuthProvider>{children}</AuthProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY} kind="privacy" testId="privacy-page" />} />
        <Route path="/syarat-ketentuan" element={<LegalPage doc={TERMS} kind="terms" testId="terms-page" />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/brewek" element={<Gacha />} />
        <Route path="/tigasatu/brewek" element={<Admin><ProtectedRoute><AdminGacha /></ProtectedRoute></Admin>} />
        <Route path="/tigasatu/artikel" element={<Admin><ProtectedRoute><AdminArticles /></ProtectedRoute></Admin>} />
        <Route path="/tigasatu/artikel/:id" element={<Admin><ProtectedRoute><AdminArticleEdit /></ProtectedRoute></Admin>} />
        <Route path="/tigasatu" element={<Admin><AdminLogin /></Admin>} />
        <Route path="/tigasatu/dashboard" element={<Admin><ProtectedRoute><AdminDashboard /></ProtectedRoute></Admin>} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Analytics />
      <AdminStatusBadge />
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
